
import {
  Usuario,
  FuncaoRPA,
  AgendamentoRPAParametro,
  Impersonate
} from '../index';


export class AgendamentoRPA {
  "Nome";
  "SAP_Ambiente";
  "SAP_User";
  "FuncaoRPAId";
  "Ativo";
  "DataCadastro";
  "UsuarioCadastro";
  "DataAlteracao";
  "UsuarioAlteracao";
  "Cron";
  "ImpersonateId";
  "id";
  UsuarioCadastroRel;
  UsuarioAlteracaoRel;
  FuncaoRPA;
  AgendamentoRPAParametros;
  Impersonate;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `AgendamentoRPA`.
   */
  static getModelName() {
    return "AgendamentoRPA";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of AgendamentoRPA for dynamic purposes.
  **/
  static factory(data) {
    return new AgendamentoRPA(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'AgendamentoRPA',
      plural: 'AgendamentoRPAs',
      path: 'AgendamentoRPAs',
      properties: {
        "Nome": {
          name: 'Nome',
          type: 'string'
        },
        "SAP_Ambiente": {
          name: 'SAP_Ambiente',
          type: 'string'
        },
        "SAP_User": {
          name: 'SAP_User',
          type: 'string'
        },
        "FuncaoRPAId": {
          name: 'FuncaoRPAId',
          type: 'number'
        },
        "Ativo": {
          name: 'Ativo',
          type: 'boolean',
          default: true
        },
        "DataCadastro": {
          name: 'DataCadastro',
          type: 'Date'
        },
        "UsuarioCadastro": {
          name: 'UsuarioCadastro',
          type: 'number'
        },
        "DataAlteracao": {
          name: 'DataAlteracao',
          type: 'Date'
        },
        "UsuarioAlteracao": {
          name: 'UsuarioAlteracao',
          type: 'number'
        },
        "Cron": {
          name: 'Cron',
          type: 'string'
        },
        "ImpersonateId": {
          name: 'ImpersonateId',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        UsuarioCadastroRel: {
          name: 'UsuarioCadastroRel',
          type: 'Usuario',
          model: 'Usuario'
        },
        UsuarioAlteracaoRel: {
          name: 'UsuarioAlteracaoRel',
          type: 'Usuario',
          model: 'Usuario'
        },
        FuncaoRPA: {
          name: 'FuncaoRPA',
          type: 'FuncaoRPA',
          model: 'FuncaoRPA'
        },
        AgendamentoRPAParametros: {
          name: 'AgendamentoRPAParametros',
          type: 'AgendamentoRPAParametro[]',
          model: 'AgendamentoRPAParametro'
        },
        Impersonate: {
          name: 'Impersonate',
          type: 'Impersonate',
          model: 'Impersonate'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/AgendamentoRPA.js